import { useContext } from 'react'

import { LocationContext } from './Router'
import { StringOrStringArray } from './types'

export function useUrlParams() {
  const ctx = useContext(LocationContext)
  if (!ctx) {
    throw new Error(
      `useUrlParams must be use with Router (BrowserRouter or StaticRouter) component`,
    )
  }
  const { matchedRoutes } = ctx
  return matchedRoutes.reduce<Record<string, StringOrStringArray>>(
    (acc, { params }) => ({
      ...acc,
      ...params,
    }),
    {},
  )
}

export function useUrlQuery() {
  const ctx = useContext(LocationContext)
  if (!ctx) {
    throw new Error(
      `useUrlQuery must be use with Router (BrowserRouter or StaticRouter) component`,
    )
  }
  const { query } = ctx
  return query
}

export function useStringUrlParam(key: string): string {
  const params = useUrlParams()
  const v = params[key]
  if (typeof v === 'string') return v
  return (v && v[0]) ?? ''
}

export function useIntUrlParam(key: string): number | undefined {
  const v = useStringUrlParam(key)
  return parseInt(v, 10) ?? undefined
}

export function useFloatUrlParam(key: string): number | undefined {
  const v = useStringUrlParam(key)
  return parseFloat(v) ?? undefined
}

export function useStringUrlQuery(key: string): string {
  const params = useUrlQuery()
  const v = params[key]
  if (typeof v === 'string') return v
  return (v && v[0]) ?? ''
}

export function useIntUrlQuery(key: string): number | undefined {
  const v = useStringUrlQuery(key)
  return parseInt(v, 10) ?? undefined
}

export function useFloatUrlQuery(key: string): number | undefined {
  const v = useStringUrlQuery(key)
  return parseFloat(v) ?? undefined
}
